export default "__VITE_ASSET__Djmfc05$__"